function TrafficSourcesTable({ sourceAttribution }) {
  const [showAll, setShowAll] = useState(false)

  if (!sourceAttribution || sourceAttribution.length === 0) {
    return null
  }

  // Sort the sourceAttribution array by count in descending order
  const sortedData = [...sourceAttribution].sort((a, b) => b.count - a.count)

  const displayData = showAll ? sortedData : sortedData.slice(0, 10)
  const hasMoreData = sortedData.length > 10

  return (
    <div className='box flex column margin-top double' id='sources'>
      <h1 className='no-margin-top'>Traffic Sources (UTM)</h1>
      <table className="flat-table">
        <thead>
          <tr>
            <th>Source</th>
            <th>Medium</th>
            <th>Campaign</th>
            <th>Visits</th>
          </tr>
        </thead>
        <tbody>
          {displayData.map((item, index) => (
            <tr key={index}>
              <td>{item.source.source || '-'}</td>
              <td>{item.source.medium || '-'}</td>
              <td>{item.source.campaign || '-'}</td>
              <td className="count-cell">{item.count}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {hasMoreData && (
        <div className="table-controls margin-top">
          {showAll ? (
            <button 
              onClick={() => setShowAll(false)}
              className="button secondary small"
            >
              See less
            </button>
          ) : (
            <button 
              onClick={() => setShowAll(true)}
              className="button secondary small"
            >
              See more ({sortedData.length - 10} more rows)
            </button>
          )}
        </div>
      )}
    </div>
  )
}

export default TrafficSourcesTable